import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  options: [],
  isLoading: false
})

const getters = {
  options: (state) => state.options,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_OPTIONS(state, payload) {
    state.options = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchOptions({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get('/api/dashboard/options')
      .then((res) => {
        const message = res.data.message
        commit('SET_OPTIONS', message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createOption({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/options`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/options')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteOption(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/options/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchOption(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/options/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.key = message.key
        vm.editForm.value = message.value
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateOption(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/options/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editOptionModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
